export default __webpack_public_path__ + "static/media/resource-other-featured-image-placeholder.3efcc0b9.svg";